const L2PlanDate = (initiative) => {
  if (!initiative?.timeline || !Array.isArray(initiative.timeline)) {
    return null;
  }

  const l2Entry = initiative.timeline.find((entry) => entry.stage === 'L2');
  
  // Ensure we have a valid date value
  if (!l2Entry?.date?.plan) {
    return null;
  }

  const date = new Date(l2Entry.date.plan);
  return isNaN(date.getTime()) ? null : date;
};

export default L2PlanDate;